import { memo, useState, useEffect } from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import moment from 'moment/moment';
import ZeroStates from '../../ZeroStates';
import { useSelector } from 'react-redux';
import { BzLoader } from '../../../components';


const Order = ({ arrOrders, searchText }) => {  //  Hari K :06-11-2023: BT-109371 message hub -receiving seach text prop

    const [arrOrderData, setArrOrderData] = useState(); // Hari K :06-11-2023: BT-109371 message hub - maintained local state for search functionality
    const isOrderAPIFailed = useSelector(state => state.messages.isOrderAPIFailed); //  Hari K :06-11-2023: BT-109371 message hub -receving isOrderAPIFailed redux state
    const IsOrderAPIPendingStatus = useSelector(state => state.messages.IsOrderAPIPendingStatus);


    // Hari K:06-11-2023: BT-109371 message hub - search functionality-start
    useEffect(() => {
        if (searchText?.length > 0) {
            const filteredArrOrderData = arrOrders?.filter((each) => each?.orderId?.toLowerCase()?.includes(searchText?.toLowerCase()) || each?.msg?.toLowerCase()?.includes(searchText?.toLowerCase()));
            setArrOrderData(filteredArrOrderData);
        } else {
            setArrOrderData(arrOrders);
        }
    }, [arrOrders, searchText]);
    // Hari K:06-11-2023: BT-109371 message hub - search functionality-end

    return (

        <Container fluid className='p-0'>
            {arrOrders?.length > 0 ?
                <>
                    {arrOrderData?.length > 0 ?
                        arrOrderData?.map((each, i) => (
                            <Row className='g-0 justify-content-evenly bdr-btm p-2'>
                                <Col md='auto'>
                                    <div className='icon-36 icon-exchange-book me-2'></div>
                                </Col>
                                <Col md={10} key={i} >
                                    <div className='font-medium font-size1 color-text mb-1'>{each.orderId}<span>:</span>{each.msg}</div>
                                    <div className='font-regular font-size1 color-subtext'>{moment(each?.date).format("DD MMM' YY")} {moment(each?.time, 'HH:mm:ss').format('h:mm A')}</div>
                                </Col>
                            </Row>
                        )) : searchText?.length ?                           
                            <div className='zero-state-alerts zero-state-alerts-xl'>
                                <div className='icon-64 icon-nodata mrgauto mb-3'></div>
                                <div className='font-medium font-size4 color-text mb-1'>No matches found</div>
                                <div className='font-regular font-size2 color-nodata'>Try adjusting your search to find what you are looking for</div>
                            </div>                          
                            : null
                    }
                </> :
                (IsOrderAPIPendingStatus && arrOrders?.length <= 0) ?
                    <div className='zero-state-alerts zero-state-alerts-xl'>
                        <BzLoader spinner={IsOrderAPIPendingStatus} spinnerContent={"Fetching Details"} />
                    </div>
                    : (arrOrders?.length <= 0 && isOrderAPIFailed) ? // Hari K: 02-11-2023 zero state changes
                        <div className='zero-state-alerts zero-state-alerts-xl'>
                            {/* // Ameersha N :15-11-2023 SAT-109371 message hub - issue - changed subText to  "Currently there are no notifications"*/}
                            <ZeroStates subText="Currently there are no notifications" isButtonShowing={false} icon='icon-64 icon-nodata mb-3 mrgauto' />
                        </div> : null
            }
        </Container>


    );
};

export default memo(Order)



